import { PageHeading } from '../PageHeading';
import Logo from '../../assets/logo.png';

export function GlobalFallback() {
  return (
  <div
    className="sign-in-container flex flex-column flex-fill"
    data-app="app-component-wrapper"
    data-view="sign-in"
  >
    <PageHeading logo={Logo} />
  </div>
  );
}

export default GlobalFallback;
